import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { PersonValidationService } from '../services/person-validation.service';
import { PersonEditorWrapperComponent } from '../modules/people/person-editor-wrapper/person-editor-wrapper.component';
import { Store } from '@ngxs/store';
import { PersonEditorState } from '../state/PersonEditorState/PersonEditor.state';
import { map, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

// FIXME: CanDeactivate is deprecated.
// see canDeactivateCorrectionsGuard for proper usage of CanDeactivateFn
export class CanDeactivatePersonGuard {
  constructor(
    private validationService: PersonValidationService,
    private store: Store
  ) {}

  canDeactivate(
    c: PersonEditorWrapperComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    // do not fire guard if user is hitting the logged out URL
    // or if editor is in readOnly mode
    return this.store.selectOnce(PersonEditorState.getReadOnly).pipe(
      mergeMap(readOnly => {
        return this.store.selectOnce(PersonEditorState.getDirectDepositFormDirty).pipe(
          map(ddFormDirty => {
            return { readOnly, ddFormDirty };
          })
        );
      }),
      mergeMap(val => {
        if (nextState.url == '/logged-out' || val.readOnly) {
          return of(true);
        } else {
          return this.validationService.onEditorLeave(
            c.addToPayrollRoute,
            nextState.url,
            val.ddFormDirty
          );
        }
      })
    );
  }
}
